module.exports = __webpack_public_path__ + "img/icon-heart.770d05c3.svg";